import React from 'react';
import img_1 from "../../../assets/img/Image/image_1.jpg";
import img_2 from "../../../assets/img/Image/image_2.jpg";
import img_3 from "../../../assets/img/Image/image_3.jpg";
import img_4 from "../../../assets/img/Image/image_4.jpg";
import img_5 from "../../../assets/img/Image/image_5.jpg";
import './style.css';

function Image(){
    return(
        <div className="d-flex justify-content-between pt-5">
            <div className="img_item">
                <img src={img_1} alt="img" />
            </div>

            <div className="img_item">
                <img src={img_2} alt="img" />
            </div>

            <div className="img_item">
                <img src={img_3} alt="img" />
            </div>

           <div className="img_item">
                <img src={img_4} alt="img" />
            </div>

            <div className="img_item">
                <img src={img_5} alt="img" />
            </div>
        </div>
    );
}

export default Image;